import * as pointColors from '../../../assets/styles/variables/colors.scss'

export default {
    root:{
        backgroundColor: pointColors.gray50,
    }
}